export const LanguagesInWashington = [
  {
    heading: "Spanish",
    detail:
      "Out of 90,417 residents of DC who do not speak English, Spanish is key among the languages spoken. Spanish translation services in DC can bridge the gap between the Spanish-speaking communities of DC and your businesses. Look to Tomedes to find out more. ",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "Chinese is the fourth major language of Washington, DC. It's a business language at that, used by a majority of businesses worldwide. If you're looking to broaden your horizons, Tomedes translators can use Simplified and Traditional Chinese for your translation projects.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Korean",
    detail:
      "Washington, DC is a diverse place, with a sizable Korean population. As a major language of the world, knowledge of the Korean language also necessitates knowledge of the Korean culture. At Tomedes, you can dissolve language barriers with Korean translation services.",
    link: "/korean-translation.php",
  },
  {
    heading: "French",
    detail:
      "French, another important business language, is spoken by a majority of Washington, DC's population. Our translators know variants of French, from Montreal to Paris to Morocco. Whichever region you're thinking of, Tomedes has translators appropriate for that region.",
    link: "/french-translation.php",
  },
  {
    heading: "Amharic",
    detail:
      "Amharic is also spoken by Washington, DC residents. You or your business can close the language gap by translating in the Amharic language for your communications, your processes and your varied documents. The Amharic language is available for translation at Tomedes.",
    link: "/amharic-translation.php",
  },
  {
    heading: "Czech",
    detail:
      "Adding to the language diversity of Washington, DC is the Czech language. If you're thinking of connecting to the Czech community in Washington, DC, or if you're thinking of broadening your horizons to the worldwide Czech communities, then you've found the right place. We can do that at Tomedes.",
    link: "/czech-translation.php",
  },
];

export const DemandServiceInWashington = [
  {
    heading: "Certified Translation Services    ",
    detail:
      "How do you know that your translations are certified translations? They have to have been authenticated by a certified translation agency. That's how you know that a certified translator has provided a faithful and accurate representation of the original document. And you can find the best at Tomedes. ",
    link: "/certified-translation.php",
  },
  {
    heading: "Legal Translation Services",
    detail:
      "Legal translation services require the linguistic expertise of legal translators who will make sure that your translations are held up in a court of law. They undergo a rigorous process of selection, and must have the necessary knowledge of the international laws for your contracts, affidavits, and other documents",
    link: "/legal-translation.php",
  },
  {
    heading: "Medical Translation Services   ",
    detail:
      "Tomedes' medical translators are native translators in your intended language. That's why medical translators know the medical terminologies as well as have expertise in medical academic journals, medical related studies, and patient records. Reach out right now.",
    link: "/medical-translation.php",
  },
  {
    heading: "Interpreting Services   ",
    detail:
      "Tomedes is fully equipped to provide interpreters for Washington, DC for UN representatives, government agencies, and the like. Washington, DC as the capital of the nation is a hub of political activity, and who better to translate the cacophony than Tomedes interpreters?",
    link: "/interpretation-services",
  },
];
